import { CALL_API } from '../../../middleware/api';
import * as API from '../../../services/ApiEndpointsConstants';
import { apiEndpoints } from '../../../services/ApiEndpointsConstants';
import * as SM_QCConstants from './SM_QCConstants';

export function getDomainsDeliveredIDs(domainId) {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints()
        .entity(API.GET_DELIVERED_IDS)
        .replace('{id}', domainId),
      types: [
        SM_QCConstants.GET_DELIVERED_IDS_REQUEST,
        SM_QCConstants.GET_DELIVERED_IDS_SUCCESS,
        SM_QCConstants.GET_DELIVERED_IDS_FAILED
      ]
    }
  };
}

export function getFirstDomainSightings(domainId) {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints()
        .entity(API.GET_FIRST_DOMAIN_SIGHTINGS)
        .replace('{id}', domainId),
      types: [
        SM_QCConstants.GET_FIRST_DOMAIN_SIGHTINGS_REQUEST,
        SM_QCConstants.GET_FIRST_DOMAIN_SIGHTINGS_SUCCESS,
        SM_QCConstants.GET_FIRST_DOMAIN_SIGHTINGS_FAILED
      ]
    }
  };
}

export function getLastDomainSightings(domainId) {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints()
        .entity(API.GET_LAST_DOMAIN_SIGHTINGS)
        .replace('{id}', domainId),
      types: [
        SM_QCConstants.GET_LAST_DOMAIN_SIGHTINGS_REQUEST,
        SM_QCConstants.GET_LAST_DOMAIN_SIGHTINGS_SUCCESS,
        SM_QCConstants.GET_LAST_DOMAIN_SIGHTINGS_FAILED
      ]
    }
  };
}

export function getReserveDomainPending() {
  return {
    [CALL_API]: {
      // endpoint: apiEndpoints().entity(API.GET_RESERVE_DOMAIN_PENDING),
      endpoint: `${apiEndpoints().entity(
        API.GET_RESERVE_DOMAIN_PENDING
      )}?limit=1`,
      types: [
        SM_QCConstants.GET_RESERVE_DOMAIN_PENDING_REQUEST,
        SM_QCConstants.GET_RESERVE_DOMAIN_PENDING_SUCCESS,
        SM_QCConstants.GET_RESERVE_DOMAIN_PENDING_FAILED
      ]
    }
  };
}

export function getReserveDomainPendingForSocialMedia(qualityPage) {
  const checkEndPoint =
    qualityPage === 'PENDING_QUALITY_CONTROL'
      ? API.GET_RESERVE_PENDING_SOCIAL_MEDIA
      : API.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING;
  return {
    [CALL_API]: {
      // endpoint: apiEndpoints().entity(API.GET_RESERVE_DOMAIN_PENDING),
      endpoint: `${apiEndpoints().entity(checkEndPoint)}?limit=1`,
      types: [
        SM_QCConstants.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_REQUEST,
        SM_QCConstants.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_SUCCESS,
        SM_QCConstants.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_FAILED
      ]
    }
  };
}

export function getReserveDomainPendingForReview(qualityPage) {
  const checkEndPoint =
    qualityPage === 'PENDING_QUALITY_CONTROL'
      ? API.GET_RESERVE_PENDING_QUALITY_CONTROL
      : API.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING;
  return {
    [CALL_API]: {
      // endpoint: apiEndpoints().entity(API.GET_RESERVE_DOMAIN_PENDING),
      endpoint: `${apiEndpoints().entity(checkEndPoint)}?limit=1`,
      types: [
        SM_QCConstants.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_REQUEST,
        SM_QCConstants.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_SUCCESS,
        SM_QCConstants.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_FAILED
      ]
    }
  };
}

export function getReserveDomainPendingForReviewByDomainName(domainName) {
  let path = API.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_BY_DOMAIN_NAME_TEST;
  return {
    [CALL_API]: {
      endpoint: `${apiEndpoints().entity(path)}?domain=${domainName}`,
      types: [
        SM_QCConstants.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_REQUEST,
        SM_QCConstants.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_SUCCESS,
        SM_QCConstants.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_FAILED
      ]
    }
  };
}

export function getDomainsImagesStatusesIds(domainId, sortOptions) {
  return {
    [CALL_API]: {
      endpoint: `${apiEndpoints()
        .entity(API.GET_DOMAINS_IMAGES_STATUSES_IDS)
        .replace('{id}', domainId)}?sort=agency,${sortOptions.order}`,
      types: [
        SM_QCConstants.GET_DOMAINS_IMAGES_STATUSES_IDS_REQUEST,
        SM_QCConstants.GET_DOMAINS_IMAGES_STATUSES_IDS_SUCCESS,
        SM_QCConstants.GET_DOMAINS_IMAGES_STATUSES_IDS_FAILED
      ]
    }
  };
}

export function getSightingsInfo(domainId) {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints()
        .entity(API.GET_SIGHTINGS_INFO)
        .replace('{id}', domainId),
      types: [
        SM_QCConstants.GET_SIGHTINGS_INFO_REQUEST,
        SM_QCConstants.GET_SIGHTINGS_INFO_SUCCESS,
        SM_QCConstants.GET_SIGHTINGS_INFO_FAILED
      ]
    }
  };
}

export function filterSightings(
  domainId,
  requestData,
  paginationOptions,
  sortingOptions = {}
) {
  const sort = Object.keys(sortingOptions).reduce((sort, key) => {
    if (sortingOptions[key]) {
      sort += `&sort=${key},${sortingOptions[key]}`;
    }

    return sort;
  }, '');

  let endpoint = `${apiEndpoints()
    .entity(API.FILTER_SIGHTINGS)
    .replace('{id}', domainId)}?page=${paginationOptions.page}&size=${
    paginationOptions.size
  }${sort}`;

  return {
    [CALL_API]: {
      config: {
        data: requestData,
        method: 'post',
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint,
      types: [
        SM_QCConstants.FILTER_SIGHTINGS_REQUEST,
        SM_QCConstants.FILTER_SIGHTINGS_SUCCESS,
        SM_QCConstants.FILTER_SIGHTINGS_FAILED
      ]
    }
  };
}

export function sendUpdatedImageURL(updatedData) {
  return {
    [CALL_API]: {
      config: {
        data: updatedData,
        method: 'put',
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint: apiEndpoints().entity(API.SEND_UPDATED_IMAGE_URL),
      types: [
        SM_QCConstants.SEND_UPDATED_IMAGE_URL_REQUEST,
        SM_QCConstants.SEND_UPDATED_IMAGE_URL_SUCCESS,
        SM_QCConstants.SEND_UPDATED_IMAGE_URL_FAILED
      ]
    }
  };
}

export function saveDomainDataAsReview(domainData) {
  return {
    [CALL_API]: {
      config: {
        data: domainData,
        method: 'put',
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint: apiEndpoints()
        .entity(API.SAVE_DOMAIN_DATA_AS_REVIEW)
        .replace('{id}', domainData.id),
      types: [
        SM_QCConstants.SAVE_DOMAIN_DATA_AS_REVIEW_REQUEST,
        SM_QCConstants.SAVE_DOMAIN_DATA_AS_REVIEW_SUCCESS,
        SM_QCConstants.SAVE_DOMAIN_DATA_AS_REVIEW_FAILED
      ]
    }
  };
}

export function updateImageStatus(imageData, imageID) {
  return {
    [CALL_API]: {
      config: {
        data: imageData,
        method: 'put',
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint: apiEndpoints()
        .entity(API.UPDATE_IMAGE_STATUS)
        .replace('{id}', imageID),
      types: [
        SM_QCConstants.UPDATE_IMAGE_STATUS_REQUEST,
        SM_QCConstants.UPDATE_IMAGE_STATUS_SUCCESS,
        SM_QCConstants.UPDATE_IMAGE_STATUS_FAILED
      ]
    }
  };
}

export function setReturnedForCommentTrue(domainData) {
  return {
    [CALL_API]: {
      config: {
        data: domainData,
        method: 'put',
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint: apiEndpoints()
        .entity(API.SET_RETURNED_FOR_COMMENT_TRUE)
        .replace('{id}', domainData.id),
      types: [
        SM_QCConstants.SET_RETURNED_FOR_COMMENT_TRUE_REQUEST,
        SM_QCConstants.SET_RETURNED_FOR_COMMENT_TRUE_SUCCESS,
        SM_QCConstants.SET_RETURNED_FOR_COMMENT_TRUE_FAILED
      ]
    }
  };
}

export function setReturnedForReview(domainData) {
  return {
    [CALL_API]: {
      config: {
        data: domainData,
        method: 'put',
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint: apiEndpoints()
        .entity(API.SET_RETURNED_FOR_REVIEW)
        .replace('{id}', domainData.id),
      types: [
        SM_QCConstants.SET_RETURNED_FOR_REVIEW_DATA_REQUEST,
        SM_QCConstants.SET_RETURNED_FOR_REVIEW_DATA_SUCCESS,
        SM_QCConstants.SET_RETURNED_FOR_REVIEW_DATA_FAILED
      ]
    }
  };
}

export function updateImagesData(imagesData) {
  return {
    [CALL_API]: {
      config: {
        data: imagesData,
        method: 'put',
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint: apiEndpoints().entity(API.UPDATE_IMAGES_DATA),
      types: [
        SM_QCConstants.UPDATE_IMAGES_DATA_REQUEST,
        SM_QCConstants.UPDATE_IMAGES_DATA_SUCCESS,
        SM_QCConstants.UPDATE_IMAGES_DATA_FAILED
      ]
    }
  };
}

export function updateDomainHoldData(domainData) {
  return {
    [CALL_API]: {
      config: {
        data: domainData,
        method: 'put',
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint: apiEndpoints()
        .entity(API.UPDATE_HOLD_DOMAIN_DATA)
        .replace('{id}', domainData.id),
      types: [
        SM_QCConstants.UPDATE_HOLD_DOMAIN_DATA_REQUEST,
        SM_QCConstants.UPDATE_HOLD_DOMAIN_DATA_SUCCESS,
        SM_QCConstants.UPDATE_HOLD_DOMAIN_DATA_FAILED
      ]
    }
  };
}

export function updateImagesHoldData(imagesData) {
  return {
    [CALL_API]: {
      config: {
        data: imagesData,
        method: 'put',
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint: apiEndpoints().entity(API.SAVE_HOLD_IMAGES_DATA),
      types: [
        SM_QCConstants.UPDATE_HOLD_IMAGE_DATA_REQUEST,
        SM_QCConstants.UPDATE_HOLD_IMAGE_DATA_SUCCESS,
        SM_QCConstants.UPDATE_HOLD_IMAGE_DATA_FAILED
      ]
    }
  };
}

export function deleteDomainHoldData(domainId) {
  return {
    [CALL_API]: {
      config: {
        method: 'delete'
      },
      endpoint: apiEndpoints()
        .entity(API.DELETE_HOLD_DOMAIN_DATA)
        .replace('{id}', domainId),
      types: [
        SM_QCConstants.DELETE_HOLD_DOMAIN_DATA_REQUEST,
        SM_QCConstants.DELETE_HOLD_DOMAIN_DATA_SUCCESS,
        SM_QCConstants.DELETE_HOLD_DOMAIN_DATA_FAILED
      ]
    }
  };
}

export const changeDomainDataInRedux = (domainData) => {
  return {
    type: SM_QCConstants.CHANGE_DOMAIN_DATA,
    data: domainData
  };
};

export const changeDomainReviewImagesData = (data, updateIndex = null) => {
  return {
    type: SM_QCConstants.CHANGE_DOMAIN_REVIEW_IMAGES_DATA,
    data: data,
    updateIndex: updateIndex
  };
};

export const clearDomainReviewImagesData = () => {
  return {
    type: SM_QCConstants.CLEAR_DOMAIN_REVIEW_IMAGES_DATA
  };
};

export const changeDeliveredData = (deliveredImageData, updateIndex) => {
  return {
    type: SM_QCConstants.ADD_TO_DELIVERED,
    data: deliveredImageData,
    updateIndex: updateIndex
  };
};

export const clearDeliveredData = () => {
  return {
    type: SM_QCConstants.CLEAR_ADD_TO_DELIVERED
  };
};

export function getDownloadedImagesData(imageId) {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints()
        .entity(API.GET_DOWNLOADED_IMAGE_DATA)
        .replace('{imageId}', imageId),
      config: {
        responseType: 'arraybuffer',
        responseEncoding: 'binary'
      },
      types: [
        SM_QCConstants.GET_DOWNLOADED_IMAGE_DATA_REQUEST,
        SM_QCConstants.GET_DOWNLOADED_IMAGE_DATA_SUCCESS,
        SM_QCConstants.GET_DOWNLOADED_IMAGE_DATA_FAILED
      ]
    }
  };
}

export const parkDomain = (id, date) => {
  return {
    [CALL_API]: {
      config: {
        method: 'post',
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint: `${apiEndpoints().entity(
        API.PARK_DOMAIN
      )}/${id}?untilDate=${date}`,
      types: [
        SM_QCConstants.PARK_DOMAIN_REQUEST,
        SM_QCConstants.PARK_DOMAIN_SUCCESS,
        SM_QCConstants.PARK_DOMAIN_FAILED
      ]
    }
  };
};
